import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "config/config";

export const getAdminAlerts = createAsyncThunk(
  "getAdminAlerts",
  async (csrAlerts, { rejectWithValue, fulfillWithValue }) => {
    try {
      let options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ClientSecret: config.PORTAL_CLIENT_SECRET,
        },
      };

      const response = await fetch(
        `${config.REG_API_BASE_URL}/alerts`,
        options
      );

      if (!response.ok) {
        rejectWithValue(response);
      } else {
        const data = await response.json();
        return fulfillWithValue(data);
      }
    } catch (error) {
      if (error.status === 500) {
        rejectWithValue(error.message);
      } else throw rejectWithValue(error.message);
    }
  }
);

const getAdminAlertsSlice = createSlice({
  name: "csrAlerts",
  initialState: {
    csrAlerts: { activeAlerts: [], expiredAlerts: [] },
    isLoading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getAdminAlerts.pending, (state) => {
      return (state = {
        ...state,
        isLoading: true,
      });
    });
    builder.addCase(getAdminAlerts.fulfilled, (state, action) => {
      return (state = {
        ...state,
        isLoading: false,
        csrAlerts: action.payload,
      });
    });
    builder.addCase(getAdminAlerts.rejected, (state) => {
      return (state = {
        ...state,
        isLoading: false,
      });
    });
  },
});

export default getAdminAlertsSlice.reducer;
